import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


export function ReadMeModal(props) {
    const [show, setShow] = useState(false);
  
    const handleClose = () => {
      props.setRead(true);
      setShow(false);
    }
    const handleShow = () => setShow(true);
  
    return (
      <>
        <Button size="sm" variant="primary" onClick={handleShow}>
        {props.buttonText}
        </Button>
  
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {props.modalText}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Elolvastam
            </Button>            
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  